import { configureStore } from '@reduxjs/toolkit'

import { counterSlice } from './counter'
import { userSlice } from '@entities/index'
import { authJoinApi } from '@pages/join/api'
import { userApi } from '@entities/user/api'
import { authLoginApi } from '@pages/login/api'
import { authExistsApi } from '@pages/auth/api'
import { subscriptionApi } from '@entities/subscription'
import { eventsApi } from '@entities/events/api'
import { sendingsApi } from '@entities/sendings/api'
import { chatApi } from '@entities/chat'
import { platformAdapterApi } from '@entities/platform-adapter'
import { APP_CONFIG } from '@shared/config'
import { segmentsApi } from '@entities/segments'


export const store = configureStore({
    reducer: {
        [counterSlice.name]: counterSlice.reducer,
        [userSlice.name]: userSlice.reducer,

        // API
        [authExistsApi.reducerPath]: authExistsApi.reducer,
        [authJoinApi.reducerPath]: authJoinApi.reducer,
        [authLoginApi.reducerPath]: authLoginApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [subscriptionApi.reducerPath]: subscriptionApi.reducer,
        [eventsApi.reducerPath]: eventsApi.reducer,
        [sendingsApi.reducerPath]: sendingsApi.reducer,
        [chatApi.reducerPath]: chatApi.reducer,
        [platformAdapterApi.reducerPath]: platformAdapterApi.reducer,
        [segmentsApi.reducerPath]: segmentsApi.reducer
    },
    devTools: process.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(authExistsApi.middleware)
        .concat(authJoinApi.middleware)
        .concat(authLoginApi.middleware)
        .concat(userApi.middleware)
        .concat(subscriptionApi.middleware)
        .concat(eventsApi.middleware)
        .concat(sendingsApi.middleware)
        .concat(chatApi.middleware)
        .concat(platformAdapterApi.middleware)
        .concat(segmentsApi.middleware)
})